import { IChipList } from '@nocode/types';
import { get } from 'lodash';
import queryString from 'query-string';

import { Platform } from 'react-native';
import { getListItems } from '../func';

export const getInitValues = (attrs: Record<string, any> = {}) => {
  let arr: any[] = [];
  for (let i = 1; i <= 4; i++) {
    arr.push({
      title: attrs.title.text,
    });
  }
  return arr;
};

export const getItemChipList = (attrs: IChipList) => {
  const { attributes, dataBinding } = attrs;

  const columnCount = get(attributes, 'columnCount', 2);

  if (Platform.OS !== 'web') {
    // App
    return dataBinding || [];
  } else {
    // web
    const search = queryString.parse(window?.location?.search);
    const target = search?.target;

    if (target) {
      // preview
      return dataBinding || [];
    } else {
      // client

      const listData = getListItems(attributes.items, 4, columnCount);

      return listData;
    }
  }
};
